import BigNumber from "bignumber.js";
import { SaleStatus } from "@axvdex/types/solana/outbid";

type ProgressBarComponentProps = {
  isComplete: boolean;
  tickets_count: string | number;
  target_ticket_amount: string | number;
  status: SaleStatus;
};
export const ProgressBarComponent = ({
  isComplete,
  tickets_count,
  target_ticket_amount,
  status,
}: ProgressBarComponentProps) => {
  const percentageFill = BigNumber(tickets_count).div(target_ticket_amount).times(100).decimalPlaces(2);

  return (
    <div style={{ width: "100%", backgroundColor: "#57586C", borderRadius: "0.5em" }}>
      <div
        style={{
          height: "1.0em",
          width: percentageFill.gt(0) && percentageFill.lt(5) ? "5%" : percentageFill.toString() + "%",
          borderRadius: "inherit",
          filter: isComplete ? "brightness(0.75)" : undefined,
          background:
            "BonusBidding" === status
              ? "var(--red-gradient)"
              : "WhitelistBidding" === status
                ? "var(--green-gradient)"
                : "var(--gradient)",
        }}
      />
    </div>
  );
};
